/**
 * Eye Dropper
 *
 * Colour picker exposing its page-world script to all origins.
 *
 * Behavioural discovery (tooling/batch-interactions.js) found no usable page-side
 * marker, so detection falls back to resource probing.
 * Manifest verified against version 4.10.3.17.
 */
import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';
const ID = 'hmdcmlfkchdmnmnmheododdhjedfccka';
export const eyeDropper: ExtensionDefinition = {
  id: ID,
  name: "Eye Dropper",
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 1000000,
  notes: "Colour picker exposing its page-world script to all origins.",
  signals: [
    { id: 'war-edropper-js', kind: 'web-accessible-resource',
      description: 'Fetch edropper.js, exposed to every origin.',
      weight: 1, run: () => probeFetch(ID, 'edropper.js') },
  ],
};
